<script>
  // 分类信息
  
  // 处理分类信息
  function handleClassInfos(h) {
    console.log(h)
  }

  export default {
    name: 'ClassInfo',
    props: {
      instance: Object
    },
    render(h) {
      const resultNode = handleClassInfos.call(this, h)
      console.log(resultNode, this.instance)
      return h('span', {}, 222)
    }
  }
</script>